// Library Import
import { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import Proptypes from 'prop-types';

// File Import
import CrossIcon from '~/images/icon/cross-gray.png';
import PlusIcon from '~/images/icon/square-plus.png';
import CircleChevronDown from '~/images/icon/circle-chevron-down-solid.svg';
import CircleChevronUp from '~/images/icon/circle-chevron-up-solid.svg';

// Components import
import { AddMapSection } from '@/components';

export const AddSinglePost = ({
  handleChange,
  handleRemovePost,
  handleAddMapSection,
  handleRemoveMapSection,
  handleCheckboxChange,
  postIndex,
  item,
  errors,
  itemTitles,
  mapTitle,
  locationsCsv,
  handleSwapPost,
  itemsLength,
  postType,
  disable
}) => {
  const url = new URL(window.location.href);
  const [typeParam, setTypeParam] = useState(null);

  useEffect(() => {
    setTypeParam(`${url.searchParams.get('type')}`);
  }, []);
  return (
    <>
      {postType === 'news' && (
        <div className='mb-3'>
          <input
            type='checkbox'
            id='map_flg'
            name='map_flg'
            value={disable ? disable : 0}
            checked={disable ? disable : 0}
            onChange={handleCheckboxChange}
          />
          <label htmlFor='map_flg'>「地図で見る」カラムの設定</label>
        </div>
      )}
      <div className='multi-section-wrapper mb-3'>
        {!postType && (
          <div className='remove-item'>
            <img
              onClick={() => handleSwapPost(postIndex, postIndex - 1)}
              src={CircleChevronUp}
              className={(postIndex === 0 && typeParam !== 'news') || (postIndex === 1 && typeParam === 'news') ? 'opacity-25 pe-none' : ''}
              alt='Circle Chevron Up Icon'
            />
            <img
              onClick={() => handleSwapPost(postIndex, postIndex + 1)}
              src={CircleChevronDown}
              className={'mx-1 ' + (postIndex + 1 > itemsLength - 1 ? 'opacity-25 pe-none' : '')}
              alt='Circle Chevron Down Icon'
            />
            {((postIndex > 0 && typeParam !== 'news') || (postIndex > 1 && typeParam === 'news')) && (
              <img onClick={() => handleRemovePost(postIndex)} src={CrossIcon} alt='Cross Icon' />
            )}
          </div>
        )}
        {/* Title Input */}
        {!postType && (
          <Form.Group className='mb-3' controlId={`post_title_${postIndex}`}>
            <Form.Label>
              コンテンツタイトル<span className='is-required'>*</span>
            </Form.Label>

            {/* 新着情報の時 */}
            {typeParam === 'news' ? (
              <Form.Control
                isInvalid={errors?.title}
                type='text'
                name='title'
                placeholder='40文字以内での記入を推奨します'
                onChange={(event) => handleChange(event, postIndex)}
                value={item?.title ? item?.title : ''}
              />
            ) : (
              <Form.Select
                name='title'
                isInvalid={errors?.title}
                value={item?.title ? item?.title : ''}
                onChange={(event) => handleChange(event, postIndex)}>
                <option value=''>選択してください...</option>
                {itemTitles?.map((option, idx) => (
                  <option key={idx} value={option}>
                    {option === '地図で見る' ? '地図で見る（他情報を設定後にご登録ください）' : option}
                  </option>
                ))}
              </Form.Select>
            )}
            {/* 自由入力の時 */}
            {item?.title === '自由入力' ? (
              <div className='pt-2'>
                <Form.Control
                  isInvalid={errors?.title_free}
                  type='text'
                  name='title_free'
                  placeholder='ご記入ください'
                  onChange={(event) => handleChange(event, postIndex)}
                  value={item?.title_free ? item?.title_free : ''}
                />
                <Form.Control.Feedback type='invalid'>{errors?.title_free}</Form.Control.Feedback>
              </div>
            ) : null}

            <Form.Control.Feedback type='invalid'>{errors?.title}</Form.Control.Feedback>
          </Form.Group>
        )}
        {/* Description */}
        {item?.title !== mapTitle && (
          <Form.Group className='mb-3' controlId={`postDescription${postIndex}`}>
            <Form.Label>
              コンテンツ本文<span className='is-required'>*</span>
            </Form.Label>
            <Form.Control
              isInvalid={errors?.description}
              type='text'
              name='description'
              as='textarea'
              rows={3}
              placeholder='ご記入ください'
              onChange={(event) => handleChange(event, postIndex)}
              value={item?.description ? item?.description : ''}
            />

            <Form.Control.Feedback type='invalid'>{errors?.description}</Form.Control.Feedback>
          </Form.Group>
        )}
        {/* Map section */}
        {item?.title === mapTitle &&
          item?.map_items?.map((item, index) => (
            <AddMapSection
              key={index}
              handleChange={handleChange}
              handleRemoveMapSection={handleRemoveMapSection}
              postIndex={postIndex}
              mapIndex={index}
              item={item}
              errors={errors?.map_items && errors?.map_items[index]}
              locationsCsv={locationsCsv}
              postType={typeParam}
              disable={disable}
              handleCheckboxChange={handleCheckboxChange}
            />
          ))}
        {/* Add new map section */}
        {item?.title === mapTitle && item?.map_items?.length < 10 && (
          <div className='add-new' onClick={() => (disable === 0 ? {} : handleAddMapSection(postIndex))}>
            <img
              className={'img ' + (typeParam !== 'news' || (typeParam === 'news' && disable) ? '' : 'disabled')}
              src={PlusIcon}
              alt='Plus Icon'
            />
          </div>
        )}
      </div>
    </>
  );
};

AddSinglePost.prototype = {
  handleChange: Proptypes.func,
  handleRemovePost: Proptypes.func,
  handleAddMapSection: Proptypes.func,
  handleRemoveMapSection: Proptypes.func,
  handleCheckboxChange: Proptypes.func,
  postIndex: Proptypes.number,
  item: Proptypes.object,
  errors: Proptypes.object,
  itemTitles: Proptypes.array,
  mapTitle: Proptypes.string,
  locationsCsv: Proptypes.array,
  postType: Proptypes.string,
  disable: Proptypes.bool
};
